// extracted by mini-css-extract-plugin
export var completionBody = "_d8-2";
export var completionCard = "_d8-0";
export var completionFooter = "_d8-3";
export var completionTitle = "_d8-1";